import { render, staticRenderFns } from "./numbers-item.vue?vue&type=template&id=14a4bbda&scoped=true&"
import script from "./numbers-item.vue?vue&type=script&lang=js&"
export * from "./numbers-item.vue?vue&type=script&lang=js&"
import style0 from "./numbers-item.vue?vue&type=style&index=0&id=14a4bbda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a4bbda",
  null
  
)

export default component.exports